import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TenantsService } from '../../../core/services/tenants.service';
import { AppConstants_settings } from '../../../core/AppConstants_Appsettings.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NSAdminbuysellRuleserviceService {
  baseurl: string = AppConstants_settings.BACKOFFICE_URL;
  companyId: string = '';
  constructor(
    private httpclient: HttpClient,
    private tenantService: TenantsService
  ) {
    this.companyId = this.tenantService.getTenantFromSubdomain();
  }
  DeleteBuyRule(arg0: any) {
    return this.httpclient.post(
      `${this.baseurl}` + '/BuySellRule/RemoveBuyingRules/' + arg0.toString(),
      {}
    );
  }
  DeleteSellRule(arg0: any) {
    return this.httpclient.post(
      `${this.baseurl}` + '/BuySellRule/RemoveSellingRules/' + arg0.toString(),
      {}
    );
  }

  GetBuyRulelist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/BuySellRule/GetBuyRulelist'
    );
  }
  addBuyRule(Buyruledata: any): Observable<any> {
    Buyruledata.companyId = this.companyId;
    return this.httpclient.post(
      `${this.baseurl}` + '/BuySellRule/addBuyRules',
      Buyruledata
    );
  }
  GetBuyRuleDetails(BuyRuleSubId: string) {
    return this.httpclient.get(
      `${this.baseurl}` +
      '/BuySellRule/GetBuyRuleDetails?BuyRuleSubId=' +
      BuyRuleSubId
    );
  }
  GetAirlinlist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/AppMasters/GetAirlinelist'
    );
  }
  GetSupplierlist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/AppMasters/GetSupplierlist'
    );
  }
  GetAirportlist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/AppMasters/GetAirportlist'
    );
  }
  GetAgentist(): Observable<any> {
    return this.httpclient.get(`${this.baseurl}` + '/AppMasters/GetAgentist');
  }
  GetGrouplist(): Observable<any> {
    return this.httpclient.get(`${this.baseurl}` + '/AppMasters/GetGrouplist');
  }
  GetBranchlist(): Observable<any> {
    return this.httpclient.get(`${this.baseurl}` + '/AppMasters/GetBranchlist');
  }
  GetChannellist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/AppMasters/GetChannellist'
    );
  }
  GetServiceslist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/AppMasters/GetServiceslist'
    );
  }
  UpdateRulePriorityAndStatus(data: any): Observable<any> {
    return this.httpclient.post(
      `${this.baseurl}` + '/BuySellRule/UpdateRulePriorityAndStatus',
      data
    );
  }
  // Change history (who / what / when) of Supplier (BUY) or Selling (SELL) rules - paged, newest first.
  GetRuleHistory(body: any): Observable<any> {
    return this.httpclient.post(
      `${this.baseurl}` + '/BuySellRule/GetRuleHistory',
      body
    );
  }
  //-------------------------------------------Sell Rules-------------------------------------------//
  GetSellRulelist(): Observable<any> {
    return this.httpclient.get(
      `${this.baseurl}` + '/BuySellRule/GetSellRulelist'
    );
  }
  addSellRule(sellruledata: any): Observable<any> {
    sellruledata.companyId = this.companyId;
    return this.httpclient.post(
      `${this.baseurl}` + '/BuySellRule/addSellRule',
      sellruledata
    );
  }
  GetSellRuleDetails(SellRuleSubId: string) {
    return this.httpclient.get(
      `${this.baseurl}` +
      '/BuySellRule/GetSellRuleDetails?SellRuleSubId=' +
      SellRuleSubId
    );
  }
}
